// extracted by mini-css-extract-plugin
module.exports = {"eula":"_27jlND1","item":"_1kNsZhS","rootBody":"_391DEtB","gridBlock":"_340LO-j","block":"_3dLac3u","number":"_3elPEgf","terms":"_1Ml5Qks","title":"_1QPwonl"};